import styled, { css } from 'styled-components';
//import clearFix from './mixins/clearFix';

const H3 = styled.h3`
  display: inline-block;
  font-weight: 900;
  font-family: ${props => props.theme.fonts.fontfaceRegular};
  line-height: 1.2;
  margin: 0;
  font-size: ${props => props.theme.fonts.sizeH3};
  color: ${props => props.theme.colors.primary};
  transition: all 0.25s ease-in-out;
  
  ${props =>
    props.upper &&
    css`
      text-transform: uppercase;
    `} 
  
  ${props =>
    props.textcenter &&
    css`
      text-align: center;
    `} 
  
  ${props =>
    props.inverted &&
    css`
      color: ${props => props.theme.colors.white};
    `} 
  
  ${props =>
    props.highlighted &&
    css`
      color: ${props => props.theme.colors.primary};
    `};

  ${props =>
    props.lighter &&
    css`
      font-weight: 400;
      font-family: ${props => props.theme.fonts.PannoTextNormal};
    `};

  ${props =>
    props.underlined &&
    css`
      /* line-height: .7; */
      /* border-bottom: 2px solid ${props => props.theme.colors.primary}; */
      text-decoration:underline;
    `}
    
`;

export default H3;



// WEBPACK FOOTER //
// ./src/components/H3/H3.js